import { SelectOrganizationModalProps } from './SelectOrganizationModal';
import { openModal } from '@core/components/ModalStack';

export async function openSelectOrgModal(props: SelectOrganizationModalProps) {
  const { SelectOrganizationModal } = await import('./SelectOrganizationModal');

  openModal(SelectOrganizationModal, props);
}
